import { NzConfig } from "ng-zorro-antd/core/config";

export const UserZorroConfig: NzConfig = {
    pageHeader: {
        nzGhost: false
    },
    badge: {
        nzShowZero: 1,
        nzOverflowCount: 99,
    },
    space: {
        nzSize: 12,
    },
    descriptions: {
        nzSize: 'small'
    }
}